import {
	DOC_SUBMITED,
	DOC_SUBMITTING,
	DOC_SUBMITTING_FAILED,
	DOC_SUBMITTING_INITIALIZE,
} from "../actions/types";
const initialState = {
	isSubmitting: false,
	isSubmitted: false,
	isFailed: false,
	id: "",
};
export default function (state = initialState, action) {
	switch (action.type) {
		case DOC_SUBMITTING:
			return {
				...state,
				isSubmitting: true,
				isSubmitted: false,
				isFailed: false,
				id: "",
			};
		case DOC_SUBMITED:
			return {
				...state,
				isSubmitting: false,
				isSubmitted: true,
				isFailed: false,
				id: action.payload,
			};
		case DOC_SUBMITTING_INITIALIZE:
			return {
				...state,
				isSubmitting: false,
				isSubmitted: false,
				isFailed: false,
				id: null,
			};

		case DOC_SUBMITTING_FAILED:
			return {
				...state,
				isSubmitting: false,
				isSubmitted: false,
				isFailed: true,
				id: "",
			};

		default:
			return state;
	}
}
